import { useAsync } from '@tiger/hooks';
import { FC } from 'react';
import ErrorBox from 'components/ErrorBox';
import Loading from 'components/Loading';
import { hasIRAAccountAndLiveAccount } from 'stores/helper';
import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';
import { getWayIcon, getWayName, getWayPath } from '../helper';
import { RecommendCurrencyEnum, RecommendDepositBankBase, RecommendDepositEnum } from '../type';
import Card from './Card';
import './style.scss';

interface SelectWayProps {
    /**
     * 是否开启 IRA 模式，IRA 模式下卡片会简化且新增内转和支票入金方式
     * @default false
     */
    isIRA?: boolean;
}

const SelectWay: FC<SelectWayProps> = ({ isIRA }) => {
    const [{ loading, error, data }, getData] = useAsync(() =>
        http
            .get<RecommendDepositBankBase[]>(API.DEPOSIT.depositWay(), {
                params: {
                    license: security.webAccountInfo?.clearing?.toUpperCase(),
                    account_type: 'bs', // 保持原来的逻辑，marsco账户传bs
                    customer_id: security.currentCustomerId
                }
            })
            .then(({ data }) => data)
    );

    const render = () => {
        if (loading) {
            return <Loading />;
        }

        if (error) {
            return <ErrorBox error={error} onClick={getData} />;
        }

        return (
            <>
                {data?.map((item, index) => {
                    let wayPath = getWayPath(item.type, isIRA);

                    if (item.type === RecommendDepositEnum.Transfer && item.currency_type.length) {
                        wayPath = `/profile/deposit/${
                            item.currency_type.includes(RecommendCurrencyEnum.USD) ? 'USD' : item.currency_type[0]
                        }`;
                    }

                    return (
                        <Card
                            key={index}
                            cardData={item}
                            to={wayPath}
                            title={getWayName(item.type, isIRA)}
                            subTitle={item.support_bank}
                            isFavorite={!!item.is_recommend}
                            icon={getWayIcon(item.type, isIRA)}
                            disabled={item.type === RecommendDepositEnum.Transfer && security.isMarscoAuditing}
                            // IRA 模式下简化显示卡片
                            mode={isIRA ? 'simple' : undefined}
                        />
                    );
                })}
                {isIRA && (
                    <>
                        {hasIRAAccountAndLiveAccount() && (
                            <Card
                                to="/profile/deposit/transfer"
                                title={__('Individual Account Contribution')}
                                icon={getWayIcon('contribution', isIRA)}
                                mode="simple"
                            />
                        )}
                        <Card
                            to="/profile/deposit/check"
                            title={__('Check Contribution')}
                            icon={getWayIcon('check', isIRA)}
                            mode="simple"
                        />
                    </>
                )}
            </>
        );
    };

    const title = security.isIRAAccount ? __('Contribution or Rollover') : __('Choose Deposit Method');

    return (
        <div className="deposit-select-way-root">
            <h3 className="main-title">{title}</h3>
            {render()}
        </div>
    );
};

export default SelectWay;
